import React from 'react';
import { motion } from 'framer-motion';
import UserAdminManagement from './UserAdminManagement';

const SettingsContent = () => (
  <motion.div
    initial={{ opacity: 0 }}
    animate={{ opacity: 1 }}
    className="space-y-8"
  >
    <h2 className="text-3xl font-display font-bold">Settings</h2>
    
    <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
      <div className="bg-[#0b0c15]/50 border border-white/10 rounded-2xl p-6">
        <h3 className="text-xl font-bold mb-6">General Settings</h3>
        <div className="space-y-4">
          <div>
            <label className="block text-sm text-gray-400 mb-2">Site Title</label>
            <input 
              type="text" 
              className="w-full bg-white/5 border border-white/10 rounded-lg px-3 py-2 text-white"
              defaultValue="Emprise"
            />
          </div>
          <div>
            <label className="block text-sm text-gray-400 mb-2">Site Description</label>
            <textarea 
              className="w-full bg-white/5 border border-white/10 rounded-lg px-3 py-2 text-white h-24"
              defaultValue="Modern portfolio website with interactive 3D elements"
            />
          </div>
          <button className="w-full py-2 bg-cyan-600 hover:bg-cyan-700 rounded-lg transition-colors">
            Save Changes
          </button>
        </div>
      </div>

      <UserAdminManagement />
    </div>
  </motion.div>
);

export default SettingsContent;
